import { getS3FileContent } from "@/pages/api/cache-pages";
import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";
import axios, { AxiosInstance } from "axios";

const api: AxiosInstance = axios.create({
  baseURL: process.env.CMS_API_BASE_URL,
});

export const fetchCommonData = async (locale: string): Promise<any> => {
  try {
    const response = await api.get(`api/common-page?locale=${locale}`);
    return response.data;
  } catch (error) {
    console.error(`Network Error fetching data for the common page:`, error);
    try {
      const response = await getS3FileContent(
        `${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/common-page.json`
      );
      return response;
    } catch (s3Error) {
      console.error(`S3 fallback also failed:`, s3Error);
      return null;
    }
  }
};

export const fetchCommonDataLp = async (): Promise<any> => {
  try {
    const response = await axios.get(
      `${process.env.CMS_API_BASE_URL_LP}/api/common-page`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching CMS data:", error);
    return null;
  }
};
